import { bgPhoto } from '../utils/img'
import ScrollReveal from './ScrollReveal'
import HeroScene3D from '../three/LazyHeroScene'
import './PageHero.css'

export default function PageHero({ eyebrow, title, text, image }) {
  return (
    <section className="page-hero" style={{ backgroundImage: `url(${bgPhoto(image, 1800, 700)})` }}>
      <div className="page-hero-scrim" />
      <HeroScene3D compact />
      <div className="container page-hero-inner">
        <ScrollReveal>
          {eyebrow && <span className="eyebrow">{eyebrow}</span>}
          <h1>{title}</h1>
          {text && <p>{text}</p>}
        </ScrollReveal>
      </div>
    </section>
  )
}
